(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fb-slideshow"] && !Shopify.designMode) return;
  try {
    
/* Flower Bunny Custom Slideshow — vanilla JS */
(function () {
  'use strict';

  class FbSlideshow {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('.fb-ss__track');
      this.slides = Array.from(root.querySelectorAll('.fb-ss__slide'));
      this.dots = Array.from(root.querySelectorAll('.fb-ss__dot'));
      this.btnPrev = root.querySelector('.fb-ss__arrow--prev');
      this.btnNext = root.querySelector('.fb-ss__arrow--next');

      this.count = this.slides.length;
      this.idx = 0;
      this.busy = false;
      this.doAutoplay = root.dataset.autoplay === 'true';
      this.speed = parseInt(root.dataset.speed, 10) || 4000;
      this.timer = null;
      this.touchStartX = 0;

      if (this.count < 2) return;
      this._bind();
      if (this.doAutoplay) this._play();
    }

    _bind() {
      this.btnPrev?.addEventListener('click', () => this._step(-1));
      this.btnNext?.addEventListener('click', () => this._step(1));

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const to = parseInt(dot.dataset.idx, 10);
          this._go(to, to >= this.idx);
        });
      });

      // Touch / swipe
      this.track.addEventListener('touchstart', (e) => {
        this.touchStartX = e.touches[0].clientX;
      }, { passive: true });

      this.track.addEventListener('touchend', (e) => {
        const dx = this.touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(dx) > 40) this._step(dx > 0 ? 1 : -1);
      }, { passive: true });

      // Keyboard
      this.root.setAttribute('tabindex', '0');
      this.root.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') this._step(-1);
        if (e.key === 'ArrowRight') this._step(1);
      });

      // Pause while hovering / focused
      this.root.addEventListener('mouseenter', () => this._pause());
      this.root.addEventListener('mouseleave', () => { if (this.doAutoplay) this._play(); });
      this.root.addEventListener('focusin', () => this._pause());
      this.root.addEventListener('focusout', () => { if (this.doAutoplay) this._play(); });
    }

    _step(dir) {
      const to = (this.idx + dir + this.count) % this.count;
      this._go(to, dir > 0);
    }

    _go(to, forward) {
      if (this.busy || to === this.idx) return;
      this.busy = true;

      const prevIdx = this.idx;
      this.idx = to;

      const outSlide = this.slides[prevIdx];
      const inSlide = this.slides[to];

      // Update dots
      this.dots[prevIdx]?.classList.remove('active');
      this.dots[prevIdx]?.setAttribute('aria-selected', 'false');
      this.dots[to]?.classList.add('active');
      this.dots[to]?.setAttribute('aria-selected', 'true');

      // Accessibility: unhide incoming slide and restore keyboard focus to its links
      inSlide.setAttribute('aria-hidden', 'false');
      inSlide.querySelectorAll('a[href], button').forEach(function (el) {
        if (el.getAttribute('tabindex') === '-1') el.removeAttribute('tabindex');
      });

      // Place incoming slide at start offset
      const enterClass = forward ? 'fb-enter-next' : 'fb-enter-prev';
      const exitClass = forward ? 'fb-exit-left' : 'fb-exit-right';

      inSlide.classList.add(enterClass);

      // Force layout so initial position is applied
      inSlide.getBoundingClientRect(); // eslint-disable-line no-unused-expressions

      // Kick off transitions
      inSlide.classList.add('fb-animating');
      outSlide.classList.add(exitClass, 'fb-animating');

      let settled = false;

      const cleanup = () => {
        if (settled) return;
        settled = true;

        // Incoming slide becomes active
        inSlide.classList.remove(enterClass, 'fb-animating');
        inSlide.classList.add('active');

        // Outgoing slide resets
        outSlide.classList.remove('active', 'fb-exit-left', 'fb-exit-right', 'fb-animating');
        outSlide.setAttribute('aria-hidden', 'true');
        outSlide.querySelectorAll('a[href], button').forEach(function (el) {
          el.setAttribute('tabindex', '-1');
        });

        this.busy = false;
      };

      inSlide.addEventListener('transitionend', cleanup, { once: true });
      // Safety fallback — fires if transitionend doesn't (e.g. reduced-motion CSS)
      setTimeout(cleanup, 900);
    }

    _play() {
      this._pause();
      this.timer = setInterval(() => this._step(1), this.speed);
    }

    _pause() {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  function initAll() {
    document.querySelectorAll('.fb-ss:not([data-fb-ready])').forEach((el) => {
      el.dataset.fbReady = 'true';
      new FbSlideshow(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when Shopify theme editor adds/loads a section
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["personaliziran-mobile-sticky-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var atcBtn = document.getElementById('pz-atc-btn');
    var priceEl = document.getElementById('pz-atc-price');
    if (!atcBtn) return;

    atcBtn.addEventListener('click', function () {
      var mainBtn = document.querySelector(
        'product-form-component button[name="add"]'
      );
      if (!mainBtn) mainBtn = document.querySelector('form[data-type="add-to-cart-form"] button[name="add"]');

      if (mainBtn && !mainBtn.disabled) {
        mainBtn.click();
      } else {
        var form = document.querySelector('form[data-type="add-to-cart-form"]');
        if (form) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });

    if (priceEl) {
      var priceTarget = document.querySelector(
        'product-price .price-item--regular, .price__regular .price-item--regular'
      );
      if (priceTarget) {
        new MutationObserver(function () {
          var text = priceTarget.textContent.trim();
          if (text) priceEl.textContent = text;
        }).observe(priceTarget, { childList: true, subtree: true, characterData: true });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
